import { BrowserNotificationsHelper } from 'model'
import React from 'react'
import { NotificationPermissionEnum } from 'utils'
import { Field } from 'view/components/inputs'
import { Selectbox, SelectboxProps } from 'view/components/options'

export interface BrowserNotificationsSelectboxProps
  extends Omit<SelectboxProps<NotificationPermission, NotificationPermission>, 'optionKeys'> {
  value: NotificationPermission
}

const optionKeys: NotificationPermission[] = [NotificationPermissionEnum.GRANTED, NotificationPermissionEnum.DENIED]

export const BrowserNotificationsSelectbox = (props: BrowserNotificationsSelectboxProps) => {
  return (
    <Selectbox
      {...props}
      optionKeys={optionKeys}
      getOptionText={BrowserNotificationsHelper.getName}
      disabled={props.value !== NotificationPermissionEnum.DEFAULT}
      value={props.value}
    />
  )
}

export const BrowserNotificationsSelectboxField = Field(BrowserNotificationsSelectbox)
